export declare namespace AppTokenSections {
	interface Sm {
		fontSize: string;
		lineHeight: string;
	}

	interface Lg {
		fontSize: string;
		lineHeight: string;
	}
}

export type AppTokens = {
	sm: AppTokenSections.Sm;
	lg: AppTokenSections.Lg;
};

export const sm: AppTokenSections.Sm = {
	fontSize: '0.875rem',
	lineHeight: '1.25rem',
};

export const lg: AppTokenSections.Lg = {
	fontSize: '1.125rem',
	lineHeight: '1.75rem',
};

/** App-wide small and large text sizes, read as `{app.sm.font.size}` in extend tokens and `dt('app.lg.lineHeight')` in CSS generators. */
export default {
	sm,
	lg,
} satisfies AppTokens;
